import { ReactElement } from 'react';

import { ChakraBox, ChakraFlex, ChakraText } from '@equip.health/ui';

import { EMPTY_DATE_FORMAT } from '~/lib/constants/patients.constants';

export interface TitleAndValueProps {
  fontSize?: string;
  icon?: ReactElement;
  isWordBreak?: boolean;
  marginBottom?: string;
  marginLeft?: string;
  marginTop?: string;
  title: string;
  titleColor?: string;
  value: string;
}

const TitleAndValue = ({
  fontSize,
  icon,
  isWordBreak = true,
  marginBottom,
  marginLeft,
  marginTop,
  title,
  titleColor = 'neutral.secondary',
  value,
}: TitleAndValueProps) => (
  <ChakraBox marginBottom={marginBottom}>
    <ChakraText
      color={titleColor}
      fontSize="12px"
      id={`${title?.split(' ').join('').toLowerCase()}__title-text`}
    >
      {title}
    </ChakraText>
    <ChakraFlex marginTop={marginTop}>
      {icon}
      <ChakraText
        color="neutral.primary"
        fontFamily={value?.includes(EMPTY_DATE_FORMAT) ? 'plain' : ''}
        fontSize={fontSize || '12px'}
        fontWeight="500"
        id={`${value?.split(' ').join('').toLowerCase()}__value-text`}
        marginLeft={marginLeft}
        style={{ wordBreak: isWordBreak ? 'break-all' : 'normal' }}
      >
        {value}
      </ChakraText>
    </ChakraFlex>
  </ChakraBox>
);

export default TitleAndValue;
